<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="`批量编辑【${editTitle}】`"
    width="600px"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <template v-if="editFormType == 'input'">
          <el-col :span="24">
            <el-form-item label="批量编辑类型" prop="editType">
              <el-select v-model="editForm.editType" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in editTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="批量编辑输入" prop="editValue">
              <el-row v-if="editForm.editType === 4" :gutter="20" type="flex" style="flex-wrap: wrap">
                <el-col :span="11">
                  <el-input v-model.trim="editForm.replaceSourceStr" placeholder="请输入被替换字符串" clearable></el-input>
                </el-col>
                <el-col :span="2">-</el-col>
                <el-col :span="11">
                  <el-input v-model.trim="editForm.editValue" placeholder="请输入替换值" clearable></el-input>
                </el-col>
              </el-row>

              <el-input v-else v-model="editForm.editValue" placeholder="请输入值" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="类型示例" prop="editType">
              <div class="tips-wrap">
                <div class="tips-label flx-align-center">
                  <div>编辑前</div>
                  <div>{{ editForm.editType === 4 ? '被替换字符串 - 替换值' : '输入值' }}</div>
                  <div>编辑后</div>
                </div>
                <div class="tips-value flx-align-center">
                  <div v-for="(item, index) in currentTips" :key="index">{{ item }}</div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </template>

        <el-col v-if="editFormType == 'radio'" :span="24">
          <el-form-item label="选择值" prop="editType">
            <el-radio-group v-model="editForm.editValue" size="mini">
              <el-radio v-for="item in editFormOptions" :key="item.value" :label="item.value">{{ item.name }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editTitle: {
      type: String,
      default: ''
    },
    // 选择修改的属性
    editPropetyArray: {
      type: Array,
      default: () => []
    },
    // 编辑类型 input 输入框；radio 单选框
    editFormType: {
      type: String,
      default: 'input'
    },
    // 单选框选项
    editFormOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      editForm: {
        editType: 1,
        editValue: '',
        replaceSourceStr: ''
      },
      editTypeOptions: [
        {
          label: '直接编辑',
          value: 1,
          tipList: ['SAJC001', 'SAJC100', 'SAJC100']
        },
        {
          label: '头部添加',
          value: 2,
          tipList: ['001', 'SAJC', 'SAJC001']
        },
        {
          label: '尾部添加',
          value: 3,
          tipList: ['001', 'SAJC', '001SAJC']
        },
        {
          label: '全局替换',
          value: 4,
          tipList: ['SAJC001SAJC', 'SAJC - JCSA', 'JCSA001JCSA']
        }
      ],
      rules: {}
    };
  },
  computed: {
    currentTips() {
      return this.editTypeOptions.find(item => item.value === this.editForm.editType).tipList;
    }
  },
  methods: {
    handleSubmit() {
      const { editType, editValue, replaceSourceStr } = this.editForm;

      if (editType == 4 && !replaceSourceStr) return this.$message.warning('被替换字符串不能为空!');
      if ((editType == 2 || editType == 3) && !editValue) return this.$message.warning('输入值不能为空!');

      if (editValue === '') {
        this.$confirm(`${editType == 1 ? '编辑值' : '替换值'}为空，是否确认继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.submitFunc();
        });
      } else {
        this.submitFunc();
      }
    },
    submitFunc() {
      this.$emit(
        'emitBatchEdit',
        this.editPropetyArray,
        this.editForm.editType,
        this.editForm.editValue,
        this.editForm.replaceSourceStr
      );
      this.$message.success('批量编辑成功!');
      this.$emit('update:visible', false);
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.tips-wrap {
  .tips-label,
  .tips-value {
    > div {
      flex: 1;
      text-align: center;
    }
  }
  .tips-label {
    color: #969696;
  }
}
</style>
